<template>
  <b-overlay
    :show="busy"
    rounded
    opacity="0.6"
    spinner-small
    spinner-variant="secondary"
    class="d-inline-block"
  >
    <b-button
      style="padding: 1px 12px;"
      @click="sendInvoice()"
      variant="secondary"
    >
      E-mail
    </b-button>
  </b-overlay>
</template>

<script>
import { Api } from '../../../../vue/api';
const API = new Api();

export default {
  props: {
    month: {
      type: String,
      required: true,
      default: '',
    },
    year: {
      type: String,
      required: true,
      default: '',
    },
    installationNumber: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data() {
    return {
      busy: false,
    };
  },
  methods: {
    /**
     * Função para enviar fatura por E-mail
     * @return {function(): void}
     */
    async sendInvoice() {
      this.busy = true;
      const { ok, errors } = await API.post('/execute', {
        path: `/invoice/send-mail/${this.month}/${this.year}/${this.installationNumber}`,
        method: 'post',
        data: null,
      });
      if (!ok) {
        this.$bvToast.toast(errors.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
        this.busy = false;
        return;
      }
      this.$bvToast.toast('Fatura enviada com sucesso!', {
        title: `Sucesso`,
        variant: 'success',
        solid: true,
      });
      this.busy = false;
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  padding: 1px 12px;
}
</style>
